import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Collapse from "react-bootstrap/Collapse";
import Swal from "sweetalert2";
import VehicleServices from '../../../services/VehicleServics';
import StoreServices from '../../../services/LocationServices';

const VehicleAdd = ({ onSuccess }) => {
  const [open2, setOpen2] = useState(true);
  const [formValues, setFormValues] = useState({
    name: '',
    category: '',
    rentalStatus: '',
    capacity: '',
    assignedStore: '',
    average: ''
  });
  const [stores, setStores] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await VehicleServices.getAllCategory();
        setCategories(response.data.data || []);
      } catch (error) {
        console.error('Error fetching categories', error);
      }
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const response = await StoreServices.getStore();
        if (response.data.data) {
          setStores(response?.data?.data);
        }
      } catch (error) {
        console.error('Failed to fetch stores', error);
      }
    };
    fetchStores();
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const requiredFields = [
      { key: 'name', message: 'Vehicle Name is required!' },
      { key: 'category', message: 'Category is required!' },
      { key: 'rentalStatus', message: 'Rental Status is required!' },
      { key: 'capacity', message: 'Capacity is required!' },
      { key: 'assignedStore', message: 'Assigned Store is required!' },
      { key: 'average', message: 'Average is required!' }
    ];

    for (let field of requiredFields) {
      if (!formValues[field.key]) {
        Swal.fire({ icon: "error", title: "Validation Error", text: field.message });
        return;
      }
    }

    try {
      const response = await VehicleServices.addVehicle(formValues);
      if (response.status === "success") {
        Swal.fire({ icon: 'success', title: 'Good job!', text: "Vehicle Added Successfully!" });
        setFormValues({ name: '', category: '', rentalStatus: '', capacity: '', assignedStore: '', average: '' });
        if (onSuccess) {
          onSuccess();
        }
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to add vehicle' });
      }
    } catch (error) {
      console.error('Failed to add vehicle', error);
      Swal.fire({ icon: 'error', title: 'Error', text: 'Failed to add vehicle' });
    }
  };

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="filter cm-content-box box-primary mt-5">
          <div className="content-title">
            <div className="cpa">
              <i className="fa fa-plus me-2" aria-hidden="true"></i>Add Vehicle
            </div>
            <div className="tools">
              <Link to={"#"} className={`SlideToolHeader ${open2 ? "collapse" : "expand"}`} onClick={() => setOpen2(!open2)}>
                <i className="fas fa-angle-up"></i>
              </Link>
            </div>
          </div>
          <Collapse in={open2}>
            <div className="cm-content-body form excerpt">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Vehicle Name</label>
                      <input type="text" 
                      className="form-control" 
                      name="name" 
                      placeholder="Enter vehicle name"
                       value={formValues.name}
                        onChange={handleInputChange}/>
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Category</label>
                      <select className="form-control"
                       name="category" value={formValues.category} 
                       onChange={handleInputChange}>
                        <option value="">Select Category</option>
                        {categories.map((category) => (
                          <option key={category._id} value={category._id}>{category.name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Rental Status</label>
                      <select 
                      className="form-control" 
                      name="rentalStatus" 
                      value={formValues.rentalStatus}
                      onChange={handleInputChange}>
                        <option value="">Select Rental Status</option>
                        <option value="Purchased">Purchased</option>
                        <option value="Rented">Rented</option>
                      </select>
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Capacity</label>
                      <input type="number" 
                      className="form-control" 
                      name="capacity" 
                      placeholder="Enter capacity"
                       value={formValues.capacity} onChange={handleInputChange}/>
                    </div>
                  </div>
                  <div className="row">
                    <div className="form-group mb-3 col-md-6">
                      <label>Assigned Store</label>
                      <select 
                      className="form-control"
                       name="assignedStore" 
                       value={formValues.assignedStore} 
                       onChange={handleInputChange}>
                        <option value="">Select Store</option>
                        {stores.map((store) => (
                          <option key={store._id} value={store._id}>{store.name}</option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group mb-3 col-md-6">
                      <label>Average Of Machine</label>
                      <input type="number" 
                      className="form-control"
                       name="average"
                        placeholder="Enter average value"
                         value={formValues.average} 
                         onChange={handleInputChange}/>
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary me-2 mt-3">Add</button>
                  <button className="btn btn-danger mt-3" type="reset">Cancel</button>
                </form>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </div>
  );
};

export default VehicleAdd;
